import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-success-message',
  templateUrl: './success-message.component.html',
  styleUrls: ['./success-message.component.scss']
})
export class SuccessMessageComponent implements OnInit {

  @Input() public message;
  @Input() public title;
  @Input() allModelsClose;

  constructor(private activeModal: NgbActiveModal,private modalService: NgbModal) { }

  ngOnInit() {
  }
  closeDialog() {
    this.activeModal.close();
    if(this.allModelsClose){
      this.modalService.dismissAll();
    }
  }
}
